<template>
  <div v-if="displayMarketing" class="col-md-4 col-sm-6 dashboard-item">
    <div v-if="marketingBox" class="card bg">
      <h2 v-if="marketingBox.title" class="m-3 text-white">{{ marketingBox.title }}</h2>
      <a v-bind:href="marketingBox.linkUrl">
        <img class="img-fluid" :src="marketingBox.imageUrl">
      </a>
    </div>
    <marketing-loading v-else />
  </div>
</template>

<script>
import MarketingLoading from './marketing-loading'
export default {
  name: 'marketing',
  components: { MarketingLoading },
  data () {
    return {
      marketingBox: null,
      displayMarketing: true
    }
  },
  mounted () {
    this.$store.dispatch('getSnippet', 'marketing-box').then(response => {
      const marketingResponse = JSON.parse(response)
      if (marketingResponse.isEnabled) {
        this.marketingBox = marketingResponse
        this.$emit('clicked', 'marketing page')
      } else {
        this.displayMarketing = false
      }
    })
  }
}
</script>
